import { Loader2 } from "lucide-react";

const Message = ({
  content,
  isUser,
  timestamp,
  avatar,
  username,
  pending = false,
  failed = false,
}) => {
  return (
    <div className={`flex ${isUser ? "justify-end" : "justify-start"} mb-4`}>
      <div
        className={`flex ${
          isUser ? "flex-row-reverse" : "flex-row"
        } items-end space-x-2 ${
          isUser ? "space-x-reverse" : ""
        } max-w-xs lg:max-w-md`}
      >
        {!isUser && avatar && (
          <img
            src={avatar}
            alt="Profile"
            className="w-8 h-8 rounded-full object-cover flex-shrink-0"
          />
        )}
        <div
          className={`px-4 py-2 rounded-2xl relative ${
            isUser
              ? `bg-purple-600 text-white rounded-br-md ${
                  pending ? "opacity-70" : ""
                } ${failed ? "bg-red-500" : ""}`
              : "bg-gray-100 text-gray-900 rounded-bl-md"
          }`}
        >
          {!isUser && username && (
            <p className="text-xs font-semibold mb-1 text-gray-600">
              {username}
            </p>
          )}
          <p className="text-sm break-words">{content}</p>
          <div className="flex items-center justify-between mt-1">
            <p
              className={`text-xs ${
                isUser ? "text-purple-200" : "text-gray-500"
              }`}
            >
              {timestamp}
            </p>
            {pending && <Loader2 size={12} className="animate-spin ml-2" />}
            {failed && (
              <span className="text-xs ml-2 text-red-200">Failed</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Message;
